import React from "react";
import {Biscuit} from "../../../../utils";
import {abonnementsActions, abonnementsUsersActions, membershipTypeActions} from "inbooma-api";

const language = Biscuit.get('user.lang').replace('-','_');
export const getAbonnements = (props:any) => {
    const { dispatch, filter } = props;

    dispatch(abonnementsActions.getAbonnements({
        token: Biscuit.get('token'),
        filter: filter,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}

export const getAbonnementsUsers = (props:any) => {
    const { dispatch, filter } = props;

    dispatch(abonnementsUsersActions.getAbonnementsUsers({
        token: Biscuit.get('token'),
        filter: filter,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}
export const getAbonnement = (props:any) => {
    const { dispatch, id } = props;

    dispatch(abonnementsActions.getAbonnement({
        token: Biscuit.get('token'),
        id: id,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}

export const deleteAbonnement = (props:any) => {
    const { dispatch, id } = props;

    dispatch(abonnementsActions.deleteAbonnement({
        token: Biscuit.get('token'),
        id: id,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}

export const addAbonnement = (props:any) => {
    const { dispatch, abonnement } = props;
    dispatch(abonnementsActions.addAbonnement({
        token: Biscuit.get('token'),
        body: abonnement,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}

export const editAbonnement = (props:any) => {
    const { dispatch, abonnement } = props;
    dispatch(abonnementsActions.editAbonnement({
        token: Biscuit.get('token'),
        id: abonnement.id,
        body: abonnement,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}

export const getMembershipTypes = (props:any) => {
    const { dispatch, filter } = props;

    dispatch(membershipTypeActions.getMembershipTypes({
        token: Biscuit.get('token'),
        filter: filter,
        parameters: {
            headers: {
                'Accept-Language': language,
                'Content-Language': language
            }
        }
    }));
}